let init = {
    payment: {
      list: [],
    },
  };
  
  const paymentReducer = (state = init, { type, payload }) => {
    switch (type) {
      case "GET_PAYMENT_GATEWAY_SETTINGS_REQUEST": {
        return {
          ...state,
          payment: {
            list: payload,
          },
        };
      }
      default: {
        return state;
      }
    }
  };
  
  export default paymentReducer;
  